import { RouteConfig } from "vue-router";

export const UserRoute: Array<RouteConfig> = [
  {
    path: "/user",
    component: () => import("@/views/admin/user/Index.vue")
  },
  {
    path: "/user/add",
    component: () => import("@/views/admin/user/Add.vue")
  },
  {
    path: "/user/edit/:id",
    component: () => import("@/views/admin/user/Edit.vue")
  }
];
